






























import Vue from "vue";
import { IHeaderProps } from "vue-simple-calendar";

export default Vue.extend({
  name: "CalendarHeader",
  props: {
    headerProps: {
      type: Object as () => IHeaderProps,
      required: true,
    },
    previousYearLabel: { type: String, default: "<<" },
    previousPeriodLabel: { type: String, default: "<" },
    nextPeriodLabel: { type: String, default: ">" },
    nextYearLabel: { type: String, default: ">>" },
  },
  data() {
    return {
      showDatePicker: false,
      currentDay: new Date(),
    };
  },
  //emits: ["input"],
  methods: {
    onInput(d: Date) {
      this.$emit("input", d);
    },
    datePickerOkHandler(date) {
      this.onInput(new Date(this.currentDay));
      this.showDatePicker = false;
    },
  },
});
